<template>
<div class="chapter">
<div class="inner_page">
<p class="P_WFP_ChapHead" id="auto_bookmark_table_of_contents_1"><span>Acknowledgments</span></p>
<p class="P_WFP_BodyText">We owe a million thanks to people who have supported the Star Challengers project, and special thanks to:</p>
<p class="P_WFP_BodyText">Pam Peterson, Dan Barstow, and Bill Readdy of the Challenger Centers for Space Science Education; Loren Coleman, Randall Bills, and Brent Evans at Catalyst Game Labs; John Silbersack at Trident Media Group; Diane Jones and Louis Moesta at WordFire, Inc.; Mary Thomson for her magical transcriptions and useful additions; Cherie Buchheim and first-reader Debra Ray for their space-geekful insights; Jake Black for his invaluable assistance in improving this book; Alan &amp; Rebecca Linkiss and Sarah &amp; Dan Hoyt for acting as sounding boards when this project was just starting out; Rose &amp; Bill Narva; Don Rodgers for cheering us on; Louise Moesta, Jonathan &amp; Jessica Cowan for smoothing the road, so Kevin &amp; Rebecca could stay on track; June’s grandchildren who encouraged and offered their suggestions; Kevin &amp; Rebecca’s grandson for showing us a new generation; the late space artist Bob McCall and astronaut entrepreneur Richard Garriott, who helped create the Challenger Center design; the staff of the Challenger Learning Center of Colorado for giving us a “home base”; Allen Steele for introducing June to Rebecca and Kevin; Jose Alvarez for his patience in waiting for this book; the CLC flight directors and teachers around the world who inspire students to aim for the stars; Susan Weikel Morrison; Cheri Winkler; Dr. Harry Kloor; our technical advisers and brainstormers: astronaut/MD Scott Parazynski, General Richard Scobee, and Dr. Edward “Mel” Tomme.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0005.vue?10575865